<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part" id="_idParaDest-13">Act I</h1>
<h2 class="subtitle _idGenParaOverride-1">Tragedy</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PastImperative12.vue?00896942